(() => {
  'use strict';
  const page = document.querySelector('.hm-v2 [data-product-page]');
  if (!page) return;
  const picker = page.querySelector('[data-option-picker]');
  const select = page.querySelector('[data-variant-select]');
  const variantsNode = document.getElementById('MarketVariants');
  if (picker && select && variantsNode) {
    const variants = JSON.parse(variantsNode.textContent);
    const measure = value => {
      const match = String(value).trim().match(/^(\d+(?:[.,]\d+)?)\s*mm\s+(\d+(?:[.,]\d+)?)\s*m(?:t)?$/i);
      return match ? {diameter: Number(match[1].replace(',', '.')), length: Number(match[2].replace(',', '.'))} : null;
    };
    const numberLabel = number => String(number).replace('.', ',');
    // Split a combined pipe size into two shopping controls while retaining Shopify's variant IDs.
    picker.querySelectorAll('[data-option-group]').forEach(group => {
      const options = [...group.querySelectorAll('[data-option-value]')];
      const dimensions = options.map(button => measure(button.dataset.optionValue));
      if (options.length < 2 || !dimensions.every(Boolean)) return;
      const fragment = document.createDocumentFragment();
      for (const part of ['diameter', 'length']) {
        const fieldset = document.createElement('fieldset');
        fieldset.className = 'atelier-option-group';
        const legend = document.createElement('legend');
        legend.textContent = part === 'diameter' ? 'Diametro' : 'Lunghezza del rotolo';
        const selectedLabel = document.createElement('span');
        selectedLabel.dataset.compoundSelected = part;
        selectedLabel.dataset.optionIndex = group.dataset.optionGroup;
        legend.append(selectedLabel);
        const values = document.createElement('div');
        values.className = 'atelier-option-values';
        [...new Set(dimensions.map(value => value[part]))].sort((a, b) => a - b).forEach(value => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'atelier-option';
          button.dataset.optionIndex = group.dataset.optionGroup;
          button.dataset.optionValue = String(value);
          button.dataset.compoundPart = part;
          button.textContent = (part === 'diameter' ? 'Ø ' : '') + numberLabel(value) + (part === 'diameter' ? ' mm' : ' m');
          values.append(button);
        });
        fieldset.append(legend, values);
        fragment.append(fieldset);
      }
      group.replaceWith(fragment);
    });
    const buttons = [...picker.querySelectorAll('button[data-option-index]')];
    const current = () => variants.find(v => String(v.id) === select.value);
    const candidateMatches = (button, variant, selected) => {
      const index = Number(button.dataset.optionIndex);
      if (!variant.options.slice(0, index).every((option, i) => option === selected.options[i])) return false;
      const part = button.dataset.compoundPart;
      if (!part) return variant.options[index] === button.dataset.optionValue;
      const dimensions = measure(variant.options[index]);
      const currentDimensions = measure(selected.options[index]);
      return dimensions && dimensions[part] === Number(button.dataset.optionValue) && (part !== 'length' || dimensions.diameter === currentDimensions.diameter);
    };
    const sync = () => {
      const selected = current();
      if (!selected) return;
      buttons.forEach(button => {
        const index = Number(button.dataset.optionIndex);
        const value = button.dataset.optionValue;
        const matching = variants.filter(v => candidateMatches(button, v, selected));
        button.disabled = matching.length === 0;
        button.classList.toggle('is-sold-out', matching.length > 0 && !matching.some(v => v.available));
        const dimensions = measure(selected.options[index]);
        button.setAttribute('aria-pressed', String(button.dataset.compoundPart ? dimensions?.[button.dataset.compoundPart] === Number(value) : selected.options[index] === value));
        button.title = matching.length === 0 ? 'Combinazione non disponibile' : matching.some(v => v.available) ? '' : 'Attualmente esaurito';
      });
      picker.querySelectorAll('[data-option-selected]').forEach(node => { node.textContent = selected.options[Number(node.dataset.optionSelected)]; });
      picker.querySelectorAll('[data-compound-selected]').forEach(node => { const part = node.dataset.compoundSelected; node.textContent = numberLabel(measure(selected.options[Number(node.dataset.optionIndex)])[part]) + (part === 'diameter' ? ' mm' : ' m'); });
      picker.querySelector('[data-selection-summary]').textContent = selected.options.map(value => { const dimensions = measure(value); return dimensions ? 'Ø ' + numberLabel(dimensions.diameter) + ' mm · ' + numberLabel(dimensions.length) + ' m' : value; }).join(' · ') + (selected.available ? '' : ' · Esaurito');
    };
    picker.addEventListener('click', event => {
      const button = event.target.closest('button[data-option-index]');
      if (!button || button.disabled) return;
      const previous = current();
      const index = Number(button.dataset.optionIndex);
      const candidates = variants.filter(v => candidateMatches(button, v, previous));
      const previousMeasure = measure(previous.options[index]);
      const score = variant => variant.options.reduce((sum, value, i) => sum + (value === previous.options[i] ? 4 : 0), variant.available ? 1 : 0) + (previousMeasure && measure(variant.options[index])?.length === previousMeasure.length ? 2 : 0);
      candidates.sort((a, b) => score(b) - score(a));
      if (!candidates[0]) return;
      select.value = String(candidates[0].id);
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
    select.addEventListener('change', sync);
    sync();
    picker.hidden = false;
    page.querySelector('[data-native-variant]').hidden = true;
  }
  const quantity = document.getElementById('ProductQuantity');
  page.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click', () => {
    if (!quantity) return;
    const min = Number(quantity.min) || 1;
    const step = Number(quantity.step) || 1;
    const max = quantity.max ? Number(quantity.max) : Infinity;
    const value = Number(quantity.value) || min;
    quantity.value = Math.min(max, Math.max(min, value + Number(button.dataset.quantityStep) * step));
    quantity.dispatchEvent(new Event('change', { bubbles: true }));
  }));
  const zoom = page.querySelector('[data-image-zoom]');
  const dialog = document.getElementById('AtelierZoom');
  if (zoom && dialog && typeof dialog.showModal === 'function') {
    zoom.addEventListener('click', event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      const image = dialog.querySelector('img');
      image.src = zoom.href;
      image.alt = page.querySelector('.product-main-image')?.alt || 'Immagine prodotto';
      dialog.showModal();
    });
    dialog.querySelector('[data-zoom-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => zoom.focus());
  }
})();
